import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--open-on-load"
export default class extends Controller {
  static values = { url: String, prefix: { type: String, default: "product" } }

  connect() {
    this.openTab(this.urlValue)
  }

  openTab(url) {
    const r = /(\d+)$/
    const windowName = [this.prefixValue, url.match(r)[0]].join('-')

    window.open(url, windowName);
  }
}
